<script>
  import * as d3 from "d3";
  import { onMount } from "svelte";

  //export let data;
  import data from "../data/release_year.json";

  let svg;
  let isMinutes = false;

  let tooltip = null;
  let tooltipX = 0;
  let tooltipY = 0;
  let chartContainer;

  
  const margin = { top: 10, right: 40, bottom: 10, left: 30 };

  function fillMissingYears(data) {
    const minYear = d3.min(data, d => d.release_year);
    const maxYear = d3.max(data, d => d.release_year);

    const map = new Map(data.map(d => [d.release_year, d]));

    const filled = [];

    for (let y = minYear; y <= maxYear; y++) {
      if (map.has(y)) {
        filled.push(map.get(y));
      } else {
        filled.push({
          release_year: y,
          total_streams: 0,
          total_minutes: 0
        });
      }
    }

    return filled;
  }

  function draw() {
    const filled = fillMissingYears(data);

    const isMobile = window.innerWidth <= 480;
    const widthFactor = isMobile ? 1 : 1.15;
    const dynamicHeight = isMobile ? 120 : 100;
    const dynamicWidth = isMobile ? 410 : 480;

    d3.select(svg).selectAll("*").remove();

    const x = d3.scaleLinear()
      .domain(d3.extent(filled, d => d.release_year))
      .range([margin.left, (dynamicWidth * widthFactor) - margin.right]);

    const maxValue = d3.max(filled, d =>
      Math.max(d.total_streams, d.total_minutes)
    );

    const y = d3.scaleSymlog()
      .domain([0, maxValue])
      .range([dynamicHeight - margin.bottom, margin.top])
      .constant(maxValue * 0.05);

    const svgEl = d3.select(svg)
    .attr(
      "viewBox",
      `0 0 ${dynamicWidth * widthFactor} ${(dynamicHeight + margin.top + margin.bottom)}`
      )
    .attr("preserveAspectRatio", "xMidYMid meet")
    .style("width", "100%")
    .style("height", "auto");

    const g = svgEl
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const lineStreams = d3.line()
      .x(d => x(d.release_year))
      .y(d => y(d.total_streams))
      .curve(d3.curveMonotoneX);

    const lineMinutes = d3.line()
      .x(d => x(d.release_year))
      .y(d => y(d.total_minutes))
      .curve(d3.curveMonotoneX);
      
    // Streams LINE
    g.append("path")
      .datum(filled)
      .attr("fill", "none")
      .attr("stroke", "#72E99C")
      .attr("stroke-width", 2.5)
      .attr("d", lineStreams);

    // Minutes LINE
    g.append("path")
      .datum(filled)
      .attr("fill", "none")
      .attr("stroke", "#1DB954")
      .attr("stroke-width", 2)
      .attr("d", lineMinutes);

    // X axis
    const xAxis = g.append("g")
      .attr("transform", `translate(0,${dynamicHeight - margin.bottom})`)
      .call(
        d3.axisBottom(x)
          .ticks(8)
          .tickSize(0)
          .tickFormat(d3.format("d"))
          .tickPadding(5)
      );

    // LEFT axis (streams)
    const yAxis = g.append("g")
      .attr("transform", `translate(${margin.left},0)`)
      .call(
        d3.axisLeft(y)
          .ticks(1)
          .tickSize(0));

    yAxis.select(".domain")
         .attr("stroke", "#2a2a2a");


    xAxis.select(".domain")
         .attr("stroke", "#2a2a2a");
 

    const dotStreams = g.append("circle")
      .attr("r", 0)
      .attr("fill","#0F0F0F")
      .attr("stroke", "#72E99C")
      .style("pointer-events", "none")
      .style("filter", "drop-shadow(0 0 6px rgba(114,233,156,0.7))")

    const dotMinutes = g.append("circle")
      .attr("r", 0)      
      .attr("fill","#0F0F0F")
      .attr("stroke", "#1DB954")
      .style("pointer-events", "none")
      .style("filter", "drop-shadow(0 0 6px rgba(29,185,84,0.7))");


    g.selectAll(".hover-zone")
      .data(filled)
      .enter()
      .append("rect")
      .attr("class", "hover-zone")
      .attr("x", d => x(d.release_year) - 10)
      .attr("y", margin.top)
      .attr("width", 20) // 👈 hover width
      .attr("height", dynamicHeight - margin.top - margin.bottom)
      .attr("fill", "transparent")
      .style("cursor", "pointer")
      .on("mouseenter", function (event, d) {

        tooltip.style.opacity = 1;

        tooltip.innerHTML = `
          <strong>${d.release_year}</strong><br/>
          Streams: ${d.total_streams.toLocaleString()}<br/>
          Minutes: ${d.total_minutes.toLocaleString()}
        `;

        dotStreams
          .attr("cx", x(d.release_year))
          .attr("cy", y(d.total_streams))
          .transition()
          .attr("r", 3);

        dotMinutes
          .attr("cx", x(d.release_year))
          .attr("cy", y(d.total_minutes))
          .transition()
          .attr("r", 3);

        const tooltipWidth = tooltip.offsetWidth || 120;

        let left;

        // If too close to right edge → place left
        if (event.pageX + tooltipWidth + 12 > isMobile) {
          left = event.pageX - tooltipWidth - 12;
        } else {
          // otherwise place right of finger
          left = event.pageX + 12;
        }

        // Prevent going off left edge
        left = Math.max(12, left);

        tooltip.style.left = left + "px";
      })

    .on("mousemove", function (event) {
      tooltip.style.left = event.pageX + 12 + "px";
      tooltip.style.top = event.pageY - 28 + "px";
    })

    .on("mouseleave", function () {
      d3.select(this)
        .attr("r", 6)
        .attr("fill", "transparent");
      tooltip.style.opacity = 0;

      dotStreams.transition().attr("r", 0);
      dotMinutes.transition().attr("r", 0);
    });
  }

  onMount(draw);  
$: if (data) {
  draw();
}

</script>

<div class="year-wrapper">
  <div class="year-header">
    <h2>By release year</h2>
  </div>
  <div class="year-chart">
    <svg bind:this={svg}></svg>
  </div>
  <div class="tooltip" bind:this={tooltip}></div>
</div>

<style>
  h2 {
    color: #FFFFFF;
    font-family: "Outfit", sans-serif;
    font-size: 1.25rem;
    font-weight: 600;
    margin-top: 0;
  }
  
  svg {
    width: 100%;
    height: auto;
  }

  .year-wrapper {
    background: #202020;
    padding: 1.25rem;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 8px rgba(29, 185, 84, 0.4);
    
    min-width: 320px;
    min-height: 0px;
  }

  .year-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .year-chart {
    max-height: 320px;
    background: #0F0F0F;
    overflow-y: hidden;
    border-radius: 12px;
    width: 100%;
    min-height: 0px;
  }

  .tooltip {
    position: absolute;
    background: #0F0F0F;
    color: #FFFFFF;
    padding: 8px 12px;
    border-radius: 8px;
    font-family: "Outfit", sans-serif;
    font-size: 12px;
    pointer-events: none;
    border: 1px solid #1DB954;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15),
                0 0 6px rgba(29,185,84,0.7);
    opacity: 0;
    transition: opacity 0.15s ease;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: #3F3F3F;
    border-radius: 4px;
  }

  @media (max-width: 480px) {
    h2 {
      font-size: 1.125rem;
      margin-top: 0;
    }

    .tooltip {
      overflow-x: hidden;
    }
  }

</style>

